<template>
  <div class="container">
    <div class="result_tips" v-html="getXssIntro(textReminder)">
    </div>

    <el-table
      :data="rewardLevelDTOList"
      border
      stripe
      style="width: 100%; margin-top: 16px;">
      <el-table-column
        prop="level"
        label="奖励档次"
        align="center">
      </el-table-column>
      <el-table-column
        prop="waterOrOrderCount"
        label="交易总流水"
        align="center"
        v-if="thresholdIndexType === 1">
        <template slot-scope="scope">
          <div>
            {{ scope.row.waterOrOrderCount }} 元
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="waterOrOrderCount"
        label="交易总笔数"
        align="center"
        v-if="thresholdIndexType === 2">
        <template slot-scope="scope">
          <div>
            {{ scope.row.waterOrOrderCount }} 笔
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="calcRule"
        label="返现规则"
        align="center">
        <template slot-scope="scope">
          <div v-if="thresholdIndexType === 1">
            <span v-if="rewardType === 1">总流水 * <span class="red">{{scope.row.calcRule}}%</span></span>
            <span v-if="rewardType === 2">超出{{scope.row.waterOrOrderCount}}元的部分 * <span class="red">{{scope.row.calcRule}}%</span></span>
            <span v-if="rewardType === 3">超过{{scope.row.waterOrOrderCount}}元，奖励 <span class="red">{{scope.row.calcRule}}</span> 元</span>
          </div>
          <div v-else>
            <span v-if="rewardType === 1">每笔返现 <span class="red">{{scope.row.calcRule}}</span> 元</span>
            <span v-if="rewardType === 2">超出{{scope.row.waterOrOrderCount}}笔后的部分每笔返现 <span class="red">{{scope.row.calcRule}}</span> 元</span>
            <span v-if="rewardType === 3">超过{{scope.row.waterOrOrderCount}}笔，奖励 <span class="red">{{scope.row.calcRule}}</span> 元</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="expectedMaximumReward"
        label="预计最高奖励金额"
        align="center"
        v-if="rewardType!==3"
        >
      </el-table-column>
    </el-table>

    <div class="instruction">
      <div>活动说明</div>
      <div>1.活动结束7天后次日0点，团油平台计算油站对应的奖励金，在活动期间或活动结束后7天之内，退款中和已退款的订单不计入至流水中；</div>
      <div>2.活动结束14天后次日10点，将奖励金打入到账户中，发放金额以实际到账为准；</div>
    </div>
  </div>
</template>
<script>
import { getXssIntro } from '@/utils/xss'

export default {
  name: 'runAchieveEffect',
  props: ['activeInfo'],
  data () {
    return {
      textReminder: '',
      thresholdIndexType: 1, // 1 流水，2 笔
      rewardLevelDTOList: [],
      rewardType: 1 // 1 全量  2 增量
    }
  },
  methods: {
    getXssIntro,
    init () {
      try {
        const { textReminder = '', thresholdIndexType = 1, rewardLevelDTOList= [], rewardType = 1 } = this.activeInfo
        this.textReminder = textReminder
        this.thresholdIndexType = thresholdIndexType
        this.rewardLevelDTOList = rewardLevelDTOList
        this.rewardType = rewardType
      } catch (error) {
        console.log(error)
      }
    },
  }
}
</script>
<style lang="less" scoped>
  .container {
    background: #fff;
    padding: 16px;
    .result_tips {
      font-weight: 500;         
      color: #323232;
      font-size: 20px;
    }
    .instruction {
      background: #F9FAFC;
      padding: 16px;
      font-size: 14px;
      line-height: 20px;
      color: #666666;
      margin-top: 16px;
    }
  }
</style>
<style>
  .blue {
    color: #4B7EFE;
  }
  .red {
    color: #FF0000;
  }
</style>
